import * as Sentry from '@sentry/react';
import * as SentryBrowser from '@sentry/browser';
import { User } from 'src/types/user';
import { Instance } from 'src/types/instance';
import { Integrations } from '@sentry/tracing';
import { TRACES } from 'src/constants/sentry';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampler: (samplingContext) => {
      switch (samplingContext.transactionContext?.name) {
        case TRACES.CHAT_LOAD:
          return 0.25;
        default:
          return 0.01;
      }
    },
    ignoreErrors: ['Request failed with status code', 'messaging/token-unsubscribe-failed'], // stop logging every failed request
  });
}

export const setUser = (user?: User, instance?: Instance) =>
  SentryBrowser.setUser({
    username: user?.employeeInternalId,
    id: user?.id.toString(),
    email: user?.email,
    instanceId: instance?.id,
    instanceName: instance?.name,
  });

export const clearUser = () =>
  SentryBrowser.configureScope((scope) => scope.setUser(null));
